

/*
    Browser-local UI preferences. Same pattern as screenState.js /
    slices/data: read once from localStorage at boot, write on change,
    swallow storage errors (private mode, quota, etc.).

    These are NOT part of the settings save flow on purpose:
      - they never leave the browser, so there is nothing to PUT,
      - they take effect immediately (no Save / Cancel bar),
      - they don't participate in settings' isDirty comparison.

    If you ever want "show tooltips" to follow a user across devices,
    move it into the preferences (user-scoped) half of the settings
    payload instead -- see PREF_FIELDS in slices/settings/actions.js.
*/

import { createSlice } from '@reduxjs/toolkit';


const SHOW_TOOLTIPS_KEY = 'ui_show_tooltips';


//  Defaults to CHECKED: absent key => true. Only an explicit 'false'
//  turns them off, so a failed/empty read can never hide the tooltips.
const readShowTooltips = () => {
    try {
        return localStorage.getItem(SHOW_TOOLTIPS_KEY) !== 'false';
    } catch (e) {
        return true;
    }
};


const initialState = {
    showTooltips: readShowTooltips(),
};


const uiPrefsSlice = createSlice({
    name: 'uiPrefs',
    initialState,
    reducers: {
        setShowTooltips: (state, action) => {
            const value = !!action.payload;
            try { localStorage.setItem(SHOW_TOOLTIPS_KEY, String(value)); } catch (e) {}
            state.showTooltips = value;
        },
    },
});


export const { setShowTooltips } = uiPrefsSlice.actions;
export default uiPrefsSlice.reducer;